import { createSlice } from '@reduxjs/toolkit';
import { fetchCountryListApi, fetchCountryCodeListApi, fetchWebStatsApi } from '../api/UtilsApi';

const initialState = {
    loading: false,
    countries: [],
    countryCode: [],
    webStats: null,
};

const countrySlice = createSlice({
  name: 'country',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      // Member Login
      .addCase(fetchCountryListApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCountryListApi.fulfilled, (state, action) => {
        state.loading = false;
        state.countries = action?.payload;
      })
      .addCase(fetchCountryListApi.rejected, (state, action) => {
        state.loading = false;
      })

       .addCase(fetchCountryCodeListApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCountryCodeListApi.fulfilled, (state, action) => {
        state.loading = false;

        // console.log(action?.payload?.data.data, "workopfj;sdjgj")
        state.countryCode = action?.payload?.data?.data;
      })
      .addCase(fetchCountryCodeListApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(fetchWebStatsApi.fulfilled, (state, action) => {
        state.webStats = action.payload?.data?.[0] ?? null;
      });
  },
});


export default countrySlice.reducer;
